@if (t.testMode()) {
  <p-panel class="ces-panel" [toggleable]="toggleable" [collapsed]="collapsed" toggler="header" [style]="{ margin: '0.5rem 0' }">
    <ng-template #header>
      <div class="cursor-pointer flex flex-row items-center gap-(--gap-tight)">
        <span>{{ panelTitle }}</span>
        <span class="text-(color:--text-secondary) ml-(--space-1)">(</span>
        <div class="text-xs inline">
          @if (pristine) {
            <span class="status-item status-pristine">Pristine</span>
          }
          @if (dirty) {
            <span class="status-item status-dirty">Dirty</span>
          }
          @if (touched) {
            <span class="status-item status-touched">Touched</span>
          }
          @if (!touched) {
            <span class="status-item status-untouched">Untouched</span>
          }
          @if (valid) {
            <span class="status-item status-valid">Valid</span>
          }
          @if (!valid) {
            <span class="status-item status-invalid">Invalid</span>
          }
          @if (disabled) {
            <span class="status-item status-disabled">Disabled</span>
          }
        </div>
        <span class="text-(color:--text-secondary)">)</span>
        <span class="flex flex-row items-center gap-(--gap-tight) ml-(--space-2)">
          <span class="value-preview bg-(--surface-2) max-w-30 font-mono truncate inline-block" [pTooltip]="getValueTooltip()">
            {{ value || 'null' }}
          </span>
        </span>
      </div>
    </ng-template>

    <p-tabView>
      <!-- Onglet État -->
      <p-tabPanel header="État">
        <div class="flex flex-col gap-(--gap-normal)">
          <div class="state-controls-container">
            <p-card styleClass="state-card">
              <ng-template pTemplate="title">
                <div class="flex justify-between items-center">
                  <span>État du contrôle</span>
                  <div class="flex gap-(--gap-tight)">
                    <p-button
                      size="small"
                      icon="pi pi-refresh"
                      styleClass="p-button-rounded-(--radius-md) p-button-text p-button-sm"
                      pTooltip="Réinitialiser l'état"
                      (onClick)="resetState()" />
                  </div>
                </div>
              </ng-template>
              <div class="flex flex-col gap-(--gap-normal)">
                <div class="state-row">
                  <div class="state-label">Pristine:</div>
                  <div class="state-value">{{ pristine }}</div>
                  <div class="state-actions">
                    <p-button
                      size="small"
                      label="set pristine"
                      [disabled]="pristine"
                      styleClass="p-button-sm p-button-outlined"
                      (onClick)="markAsPristine()" />
                  </div>
                </div>

                <div class="state-row">
                  <div class="state-label">Dirty:</div>
                  <div class="state-value">{{ dirty }}</div>
                  <div class="state-actions">
                    <p-button
                      size="small"
                      label="set dirty"
                      [disabled]="dirty"
                      styleClass="p-button-sm p-button-outlined"
                      (onClick)="markAsDirty()" />
                  </div>
                </div>

                <div class="state-row">
                  <div class="state-label">Touched:</div>
                  <div class="state-value">{{ touched }}</div>
                  <div class="state-actions">
                    <p-button
                      size="small"
                      label="set touched"
                      [disabled]="touched"
                      styleClass="p-button-sm p-button-outlined"
                      (onClick)="markAsTouched()" />
                  </div>
                </div>

                <div class="state-row">
                  <div class="state-label">Untouched:</div>
                  <div class="state-value">{{ !touched }}</div>
                  <div class="state-actions">
                    <p-button
                      size="small"
                      label="set untouched"
                      [disabled]="!touched"
                      styleClass="p-button-sm p-button-outlined"
                      (onClick)="markAsUntouched()" />
                  </div>
                </div>

                <div class="state-row">
                  <div class="state-label">Valid:</div>
                  <div class="state-value" [ngClass]="{ 'text-green-500': valid, 'text-red-500': !valid }">{{ valid }}</div>
                  <div class="state-actions">
                    <div class="flex gap-(--gap-tight)">
                      @if (!valid) {
                        <p-button
                          size="small"
                          label="set valid"
                          styleClass="p-button-sm p-button-outlined p-button-success"
                          (onClick)="setValidity(true)" />
                      }
                      @if (valid) {
                        <p-button
                          size="small"
                          label="set invalid"
                          styleClass="p-button-sm p-button-outlined p-button-danger"
                          (onClick)="setValidity(false)" />
                      }
                    </div>
                  </div>
                </div>

                <div class="state-row">
                  <div class="state-label">Disabled:</div>
                  <div class="state-value">{{ disabled }}</div>
                  <div class="state-actions">
                    <div class="flex gap-(--gap-tight)">
                      @if (!disabled) {
                        <p-button
                          size="small"
                          label="Désactiver"
                          styleClass="p-button-sm p-button-outlined"
                          (onClick)="setDisabled(true)" />
                      }
                      @if (disabled) {
                        <p-button
                          size="small"
                          label="Activer"
                          styleClass="p-button-sm p-button-outlined"
                          (onClick)="setDisabled(false)" />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </p-card>
          </div>

          <p-divider />

          <div class="value-editor">
            <p-card styleClass="value-card">
              <ng-template pTemplate="title">
                <div class="flex justify-between items-center">
                  <span>Valeur actuelle</span>
                  <div class="flex gap-(--gap-tight)">
                    <p-button
                      size="small"
                      icon="pi pi-trash"
                      styleClass="p-button-rounded-(--radius-md) p-button-text p-button-sm p-button-danger"
                      pTooltip="Définir à null"
                      (onClick)="setNullValue()" />
                    <p-button
                      size="small"
                      icon="pi pi-clock"
                      styleClass="p-button-rounded-(--radius-md) p-button-text p-button-sm"
                      pTooltip="Heure actuelle"
                      (onClick)="setCurrentTime()" />
                  </div>
                </div>
              </ng-template>
              <div class="value-display">
                <div class="mb-(--space-2)"><strong>Valeur:</strong> {{ value || 'null' }}</div>

                <div class="mb-(--space-2)">
                  <div class="p-inputgroup">
                    <input
                      type="text"
                      pInputText
                      [(ngModel)]="simpleValueInput"
                      placeholder="HH:mm ou HH:mm:ss"
                      pattern="^([0-1]?[0-9]|2[0-3]):([0-5]?[0-9])(?::([0-5]?[0-9]))?$" />
                    <button type="button" pButton icon="pi pi-check" (click)="updateSimpleValue()"></button>
                  </div>
                  <small class="text-(color:--text-secondary)">Format: HH:mm ou HH:mm:ss (ex: 14:30 ou 14:30:45)</small>
                </div>

                <div class="preset-times flex flex-wrap gap-(--gap-tight)">
                  @for (preset of timePresets; track preset) {
                    <p-button
                      size="small"
                      [label]="preset"
                      styleClass="p-button-sm p-button-outlined"
                      (onClick)="setPresetTime(preset)" />
                  }
                </div>
              </div>
            </p-card>
          </div>
        </div>
      </p-tabPanel>

      <!-- Onglet Erreurs -->
      <p-tabPanel header="Erreurs">
        <div class="flex flex-col gap-(--gap-normal)">
          @if (!hasErrors()) {
            <p-card styleClass="no-errors-card">
              <div class="flex items-center justify-center p-(--space-3)">
                <i class="pi pi-check-circle text-green-500 text-xl mr-(--space-2)"></i>
                <span class="text-green-500">Aucune erreur de validation</span>
              </div>
            </p-card>
          }

          @if (hasErrors()) {
            <p-card styleClass="errors-card">
              <ng-template pTemplate="title">
                <div class="flex justify-between items-center">
                  <span class="text-red-500">
                    <i class="pi pi-exclamation-circle mr-(--space-2)"></i>
                    Erreurs de validation
                  </span>
                  <p-button
                    size="small"
                    icon="pi pi-trash"
                    styleClass="p-button-rounded-(--radius-md) p-button-text p-button-sm"
                    pTooltip="Effacer toutes les erreurs"
                    (onClick)="clearAllErrors()" />
                </div>
              </ng-template>

              @if (errorMessages && errorMessages.length > 0) {
                <div class="error-section">
                  <h4 class="text-sm font-semibold mb-(--space-2)">Messages d'erreur:</h4>
                  <div class="flex flex-wrap gap-(--gap-tight) mb-(--space-3)">
                    @for (msg of errorMessages; track msg) {
                      <p-chip [label]="msg" styleClass="error-chip" [removable]="true" (onRemove)="removeErrorMessage(msg)" />
                    }
                  </div>
                </div>
              }

              @if (errors && Object.keys(errors).length > 0) {
                <div class="error-section">
                  <h4 class="text-sm font-semibold mb-(--space-2)">Erreurs:</h4>
                  <ul class="error-list">
                    @for (error of getErrorEntries(); track error.key) {
                      <li class="flex justify-between items-center">
                        <span>{{ error.key }}: {{ error.value | json }}</span>
                        <p-button
                          size="small"
                          icon="pi pi-times"
                          styleClass="p-button-rounded-(--radius-md) p-button-text p-button-sm p-button-danger"
                          (onClick)="removeError(error.key)" />
                      </li>
                    }
                  </ul>
                </div>
              }

              @if (externalErrors && Object.keys(externalErrors).length > 0) {
                <div class="error-section">
                  <h4 class="text-sm font-semibold mb-(--space-2)">Erreurs externes:</h4>
                  <ul class="error-list">
                    @for (error of getExternalErrorEntries(); track error.key) {
                      <li class="flex justify-between items-center">
                        <span>{{ error.key }}: {{ error.value }}</span>
                        <p-button
                          size="small"
                          icon="pi pi-times"
                          styleClass="p-button-rounded-(--radius-md) p-button-text p-button-sm p-button-danger"
                          (onClick)="removeExternalError(error.key)" />
                      </li>
                    }
                  </ul>
                </div>
              }

              <p-divider />

              <div class="add-error-section">
                <h4 class="text-sm font-semibold mb-(--space-2)">Ajouter une erreur:</h4>
                <div class="flex flex-col sm:flex-row gap-(--gap-normal) mb-(--space-2)">
                  <div class="p-inputgroup flex-1">
                    <span class="p-inputgroup-addon">Type</span>
                    <input type="text" pInputText [(ngModel)]="newErrorKey" placeholder="required" />
                  </div>
                  <div class="p-inputgroup flex-1">
                    <span class="p-inputgroup-addon">Valeur</span>
                    <input type="text" pInputText [(ngModel)]="newErrorValue" placeholder="true" />
                  </div>
                  <p-button size="small" label="Ajouter" styleClass="p-button-sm" [disabled]="!newErrorKey" (onClick)="addError()" />
                </div>
              </div>
            </p-card>
          }
        </div>
      </p-tabPanel>

      <!-- Onglet Configuration -->
      <p-tabPanel header="Configuration">
        <div class="flex flex-col gap-(--gap-normal)">
          <p-card styleClass="config-card">
            <ng-template pTemplate="title">
              <span>Configuration du champ</span>
            </ng-template>

            <div class="grid">
              <div class="col-12 md:col-6">
                <div class="config-item">
                  <div class="config-label">Label:</div>
                  <div class="config-value">{{ label || '(non défini)' }}</div>
                </div>

                <div class="config-item">
                  <div class="config-label">Min Time:</div>
                  <div class="config-value">{{ minTime || '(non défini)' }}</div>
                </div>

                <div class="config-item">
                  <div class="config-label">Max Time:</div>
                  <div class="config-value">{{ maxTime || '(non défini)' }}</div>
                </div>
              </div>

              <div class="col-12 md:col-6">
                <div class="config-item">
                  <div class="config-label">Required:</div>
                  <div class="config-value">
                    <p-checkbox [disabled]="true" [binary]="true" [(ngModel)]="required" [readonly]="true" />
                  </div>
                </div>

                <div class="config-item">
                  <div class="config-label">Show Seconds:</div>
                  <div class="config-value">
                    <p-checkbox [disabled]="true" [binary]="true" [(ngModel)]="showSeconds" [readonly]="true" />
                  </div>
                </div>

                <div class="config-item">
                  <div class="config-label">Float Label:</div>
                  <div class="config-value">
                    <p-checkbox [disabled]="true" [binary]="true" [(ngModel)]="floatLabel" [readonly]="true" />
                  </div>
                </div>
              </div>
            </div>
          </p-card>
        </div>
      </p-tabPanel>

      <!-- Onglet Événements -->
      <p-tabPanel header="Events">
        <div class="flex flex-col gap-(--gap-normal)">
          <p-card styleClass="events-card">
            <ng-template pTemplate="title">
              <div class="flex justify-between items-center">
                <span>Déclencher</span>
                <p-button
                  size="small"
                  icon="pi pi-trash"
                  styleClass="p-button-rounded-(--radius-md) p-button-text p-button-sm"
                  pTooltip="Effacer le journal"
                  (onClick)="clearEventLog()" />
              </div>
            </ng-template>

            <div class="event-buttons flex flex-wrap gap-(--gap-normal) mb-(--space-3)">
              <p-button size="small" label="Change" styleClass="p-button-sm p-button-outlined" (onClick)="triggerEvent('change')" />
              <p-button size="small" label="Focus" styleClass="p-button-sm p-button-outlined" (onClick)="triggerEvent('focus')" />
              <p-button size="small" label="Blur" styleClass="p-button-sm p-button-outlined" (onClick)="triggerEvent('blur')" />
            </div>

            <div class="event-log">
              <h4 class="text-sm font-semibold mb-(--space-2)">Journal d'événements:</h4>
              @if (eventLog.length === 0) {
                <div class="text-(color:--text-secondary) text-sm">Aucun événement déclenché</div>
              }
              @if (eventLog.length > 0) {
                <ul class="event-list">
                  @for (event of eventLog; track event.time) {
                    <li class="event-item">
                      <span class="event-time">{{ event.time | date: 'HH:mm:ss.SSS' }}</span>
                      <span class="event-name">{{ event.name }}</span>
                    </li>
                  }
                </ul>
              }
            </div>
          </p-card>
        </div>
      </p-tabPanel>
    </p-tabView>
  </p-panel>
}
